import React     from 'react';
import PropTypes from 'prop-types';
import './ResultRow.scss';

/** One gradient row: icon | label | value-pill */
export default function ResultRow({ data, onClick }) {
  const { icon, label, value } = data;

  return (
    <button className="result-row" onClick={() => onClick(data)}>
      <span className="icon">{icon}</span>
      <span className="label">{label}</span>
      <span className="pill">{value}</span>
    </button>
  );
}

ResultRow.propTypes = {
  data: PropTypes.shape({
    icon : PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired
};
